import { IWPLink } from "@/src/types";
import { MainSection } from "@/styles/global";
import React from "react";
import S from "./VideoCards.styled";
import Button from "@/components/global-components/Button";

export interface VideoCardsProps {
  title: string;
  text: string;
  backgroundColor: string;
  backgroundColorCards: string;
  videoCardsList: {
    videoUrl: string;
    cardTitle: string;
    cardText: string;
    cardButton: IWPLink;
  }[];
}

const VideoCards: React.FC<VideoCardsProps> = ({
  title,
  text,
  backgroundColor,
  backgroundColorCards,
  videoCardsList,
}) => {
  const renderCards = videoCardsList?.map(
    ({ cardButton, videoUrl, cardText, cardTitle }, index) => {
      return (
        <S.Card key={index} $bgColor={backgroundColorCards}>
          {videoUrl && (
            <S.CardVideo dangerouslySetInnerHTML={{ __html: videoUrl }} />
          )}
          <S.TextWrapper>
            {cardTitle && <S.CardTitle>{cardTitle}</S.CardTitle>}
            {cardText && <S.Text>{cardText}</S.Text>}
            {cardButton && (
              <S.ButtonWrapper>
                <Button link={cardButton} type="primary" />
              </S.ButtonWrapper>
            )}
          </S.TextWrapper>
        </S.Card>
      );
    }
  );

  return (
    <MainSection $bgColor={backgroundColor}>
      <S.Inner>
        <S.TitleWrapper>
          {title && <S.Title>{title}</S.Title>}
          {text && <S.Text>{text}</S.Text>}
        </S.TitleWrapper>
        <S.CardsWrapper $arrayLength={videoCardsList.length}>
          {renderCards}
        </S.CardsWrapper>
      </S.Inner>
    </MainSection>
  );
};

export default VideoCards;
